/* Copyright 2022 SIB Visions GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */

import { useContext } from "react";
import { IAPI } from "../../API";
import { appContext } from "../../contexts/AppProvider";

/** This hook gives users access to the api functions */
const useAPI = (): IAPI => {
    /** Use context to gain access for contentstore and server methods */
    const context = useContext(appContext);

    return context.api
}
export default useAPI;